import { useCallback, useState } from 'react';
import { useAngularContext } from 'AngularContext';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { streamDashboardPath, type StreamForStreamDashboard } from 'Lessons';
import { waitForPendingStreamSave } from './waitForPendingStreamSave';

/*
    Sets completedStreamIndex so the dashboard bounces the certificate. Waits for any pending progress save
    before it navigates.
*/
export function useContinueFromCompleted(stream: StreamForStreamDashboard) {
    const $injector = useAngularContext();
    const { loadRoute } = useNavigationHelper();
    const [isContinuing, setIsContinuing] = useState(false);

    const onContinue = useCallback(async () => {
        setIsContinuing(true);

        const StreamProgressionStatus = $injector.get<{ completedStreamIndex: string }>('StreamProgressionStatus');
        StreamProgressionStatus.completedStreamIndex = stream.id;

        await waitForPendingStreamSave($injector, stream.id);

        loadRoute(streamDashboardPath({ streamTitle: stream.title, streamId: stream.id }));
    }, [stream, $injector, loadRoute]);

    return { onContinue, isContinuing };
}
